import axios from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { routes } from '../../routes';
import { VideoResourceType } from '../types';

export const useGetVideoResources = (): UseQueryResult<VideoResourceType[], unknown> =>
  useQuery(['videos'], () => axios.get(routes.videoResources).then((res) => res.data), {
    refetchOnWindowFocus: false,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff: 1s, 2s, 4s, etc.
  });

export default {};
